export const USER_EMAIL="USER_EMAIL";
export const USER_NAME="USER_NAME";
export const USER_PASSWORD="USER_PASSWORD";
export const USER_CONFIRMPASSWORD="USER_CONFIRMPASSWORD";
export const IS_LOGGEDIN="IS_LOGGEDIN";
export const USER_TOKEN="USER_TOKEN";
export const AUTH_LOADING_TRUE="AUTH_LOADING_TRUE";
export const AUTH_LOADING_FALSE="AUTH_LOADING_FALSE";
export const AUTH_ERROR="AUTH_ERROR";
export const LOGOUT_USER="LOGOUT_USER";
export const GUEST_LOGIN="GUEST_LOGIN";
export const SET_STATUS_TRUE="SET_STATUS_TRUE";
export const SET_STATUS_FALSE="SET_STATUS_FALSE";
export const   LOAD_AUTH="LOAD_AUTH";